import * as React from 'react';
import Component from '../../AbstractComponent';
import { PaymentInterface } from '../../../Entity/Entities/Payment/PaymentInterface';
import Payment2State from '../../Partials/Payment/Payment2State';
import Button from '@material-ui/core/Button';
import Constants from '../../../Action/Constants';
import { CoachUpdateCounterparty } from '../Dialog/CoachUpdateCounterparty';

export default class Payment2Summary extends Component {
  public state = {
    openCoachUpdateCounterparty: false,
  };

  constructor(public props) {
    super(props);
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: '11px',
          color: '#80808091',
          marginTop: '5px',
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  };

  public unlinkCounterparty = () => {
    this.setState({
      isSaving: true,
    });
    const payload: any = {
      paymentId: this.props.payment.id,
      payment: {
        companyId: null,
        contactId: null,
      },
    };

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START,
        payload: {
          ...payload,
        },
        onSuccess: () => {
          this.setState(
            {
              errorFields: [],
              isSaving: false,
            },
            this.props.initializePage
          );
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields,
            errorMessage: err.message,
          });
        },
      });
    });
  };

  public changeCounterparty = (event, payment: PaymentInterface) => {
    if (Object.keys(payment?.amountDetails).length > 0) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('readonly_payment_update_forbidden'),
          type: 'error',
        },
      });
    } else {
      if (!payment?.personId && !payment?.companyId) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
          openCoachUpdateCounterparty: true,
        });
      } else {
        event.preventDefault();
        event.stopPropagation();
        this.unlinkCounterparty();
      }
    }
  };

  public render() {
    const payment: PaymentInterface = this.props.payment;
    const agencyBankAccounts = this.getAgencyBankAccounts();
    const agencyBankAccount = agencyBankAccounts.find((account) => {
      return account.id === payment?.agencyBankAccount;
    });

    return (
      <div className="payment-summary">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div className="title">
            {payment?.isReceived
              ? this.trans('payment-summary-title/receivable')
              : this.trans('payment-summary-title/payable')}
          </div>
          <div className="date">
            {this.formatter.formatDate(payment?.dateOfThePayment)}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <div className="counterparty">
            {`${payment?.getPayerDisplayName()}	${
              payment?.hasSavingsType
                ? `(${this.trans('charge/payment-summary-title/savings')})`
                : ''
            }`}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex' }}>
              <div className="currency">{payment?.currency?.getIso()}</div>
              <div className="amount">
                {/* {!this.props.newCardStyles ?  */}
                {this.formatter.formatNumber(payment?.amount)}
                {/* // : this.formatter.formatNumber(payment?.amountUsedForCharges(payment?.chargeIds))} */}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {payment.description && (
            <table>
              <tr>
                <td className="align-left first-column">
                  {this.trans('payment-summary-details/paidfrom')}
                </td>
                <td className="align-left">
                  {payment?.isReceived && (
                    <div>
                      {payment?.mainBankAccountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {payment?.name
                          ? payment?.name
                          : this.trans('payment-summary-details/unknown')}
                      </span>

                      <Button
                        color="primary"
                        style={{
                          padding: '4px 10px',
                          marginLeft: '12px',
                          lineHeight: 'normal',
                          whiteSpace: 'nowrap',
                          border: '1px solid',
                        }}
                        onClick={(event) => {
                          this.changeCounterparty(event, payment);
                        }}
                      >
                        {payment?.counterparty
                          ? this.trans('unlink-counterparty')
                          : this.trans('link-counterparty')}
                      </Button>
                    </div>
                  )}
                  {payment?.isPaid && (
                    <div>
                      {agencyBankAccount?.accountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {agencyBankAccount?.name}
                      </span>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td className="align-left first-column">
                  {this.trans('payment-summary-details/paidto')}
                </td>
                <td className="align-left">
                  {payment?.isPaid && (
                    <div>
                      {payment?.mainBankAccountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {payment?.name
                          ? payment?.name
                          : this.trans('payment-summary-details/unknown')}
                      </span>
                      <Button
                        color="primary"
                        style={{
                          padding: '4px 10px',
                          marginLeft: '12px',
                          lineHeight: 'normal',
                          whiteSpace: 'nowrap',
                          border: '1px solid',
                        }}
                        onClick={(event) => {
                          this.changeCounterparty(event, payment);
                        }}
                      >
                        {payment?.personId || payment?.companyId
                          ? this.trans('unlink-counterparty')
                          : this.trans('link-counterparty')}
                      </Button>
                    </div>
                  )}
                  {payment?.isReceived && (
                    <div>
                      {agencyBankAccount?.accountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {agencyBankAccount?.name}
                      </span>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td className="align-left first-column">
                  {`${this.trans('description')}::`}
                </td>
                <td className="align-left">{payment?.description}</td>
              </tr>
              {/* <tr>
                <td className="align-left first-column">
                  {this.trans('payment-summary-details/paidfrom')}
                </td>
                <td className="align-left">
                  {payment?.isReceived && (
                    <div>
                      {payment?.mainBankAccountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {payment?.name
                          ? payment?.name
                          : this.trans('payment-summary-details/unknown')}
                      </span>

                      <Button
                        color="primary"
                        style={{
                          padding: '4px 10px',
                          marginLeft: '12px',
                          lineHeight: 'normal',
                          whiteSpace: 'nowrap',
                          border: '1px solid',
                        }}
                        onClick={(event) => {
                          this.changeCounterparty(event, payment);
                        }}
                      >
                        {payment?.counterparty
                          ? this.trans('unlink-counterparty')
                          : this.trans('link-counterparty')}
                      </Button>
                    </div>
                  )}
                  {payment?.isPaid && (
                    <div>
                      {agencyBankAccount?.accountId}
                      <span style={{ marginLeft: '5px', color: '#ababab' }}>
                        {agencyBankAccount?.name}
                      </span>
                    </div>
                  )}
                </td>
              </tr> */}
            </table>
          )}

          <div
            style={{
              position: 'relative',
              top: '0px',
              marginLeft: 'auto',
              minWidth: 'fit-content',
            }}
          >
            {/* {!this.props.newCardStyles ?  */}
            <Payment2State {...this.props} payment={payment} />

            {/* : !payment?.isFullyUsed() && (
							<div style={{display: "flex", alignItems: "center"}}>
								<div style={{fontSize: "16px"}}>
									{this.trans("payment").toLowerCase()}
								</div>
								<div style={{marginLeft: "5px", fontSize: "16px"}}>
									{this.formatter.formatNumber(payment?.amount)}
								</div>
								<div style={{marginLeft: "5px", fontSize: "16px"}}>
									{payment?.currency?.getIso()}
								</div>
							</div>
						)} */}
            {this.state.openCoachUpdateCounterparty && (
              <CoachUpdateCounterparty
                {...this.props}
                payment={this.props.payment}
                openCoachUpdateCounterparty={
                  this.state.openCoachUpdateCounterparty
                }
                // initializePage={this.props.initializePage}
                onCloseCoach={() => {
                  this.setState({
                    openCoachUpdateCounterparty: false,
                  });
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
